<template>
  <nav class="navbar-links">
    <RouterLink
      to="/"
      class="navbar-link"
    >
      {{ $t('navbar.home') }}
    </RouterLink>

    <RouterLink
      to="/about"
      class="navbar-link"
    >
      {{ $t('navbar.about') }}
    </RouterLink>

    <RouterLink
      to="/how-it-works"
      class="navbar-link"
    >
      {{ $t('navbar.works') }}
    </RouterLink>

    <RouterLink
      to="/pricing"
      class="navbar-link"
    >
      {{ $t('navbar.pricing') }}
    </RouterLink>

    <RouterLink
      to="/contact"
      class="navbar-link"
    >
      {{ $t('navbar.contact') }}
    </RouterLink>
  </nav>
</template>

<script>
export default {
  name: 'NavbarLinks'
}
</script>